<div class="urgency">
    <div class="urgency-title">
        Salget til næste trækning lukker om
    </div>
    <div class="urgency-countdown">
        <app-countdown-v2 [date]="countdownDate"></app-countdown-v2>
    </div>
</div>
